export const SET_RECEIVER_METADATA = 'SET_RECEIVER_METADATA';

export const setReceiverMetadata = (payload) => {
  return {
    type: SET_RECEIVER_METADATA,
    payload: payload,
  };
};
